import { Injectable } from '@angular/core';
import { IAdapter } from '@drl/core/api/adapters/i-adapter';
import { Patient } from '@drl/shared/models';
import * as moment from 'moment';
import { CurrentUserAdapter } from '@drl/core/auth/adapters/current-user-adapter.service';

@Injectable()
export class PatientAdapter implements IAdapter<Patient> {
  constructor(private readonly userAdapter: CurrentUserAdapter) { }

  adaptToModel(resp: any): Patient {
    let patient: Patient = new Patient();

    if (resp) {
      patient = Object.assign({}, resp, this.userAdapter.adaptToModel(resp));
    }

    if (patient.dob) {
      const currentMoment = moment();
      const dobMoment = moment(patient.dob);
      patient.age = currentMoment.diff(dobMoment, 'years');
    }
    return patient;
  }

  adaptFromModel(data: Patient): any {
    // Restore some values
    const dataToSend: any = Object.assign({}, data);
    dataToSend.gender = data.genderEnum;
    dataToSend.status = data.statusEnum;
    if (dataToSend.email === '') {
      dataToSend.email = null;
    }
    if(!dataToSend.caregiverId){
      delete dataToSend.caregiverId;
    }
    delete dataToSend.username;
    delete dataToSend.designation;
    delete dataToSend.lastLogin;
    delete dataToSend.photoUrl;
    delete dataToSend.authClientIds;
    delete dataToSend.bio;
    delete dataToSend.experience;
    delete dataToSend.qualification;
    delete dataToSend.lang;
    delete dataToSend.relation;
    delete dataToSend.photo;
    delete dataToSend.genderEnum;
    delete dataToSend.statusEnum;
    delete dataToSend.cancerTypeLc;
    delete dataToSend.occurence;
    delete dataToSend.treatmentStageId;
    delete dataToSend.waConsentTime;
    if (Object(dataToSend).hasOwnProperty("isSelfOnb")) {
      delete dataToSend.isSelfOnb;
    }
    return dataToSend;
  }
}
